import products from "./products";
import http from "./http";
import rscope from "./rootScope";
import utils from "./utils";
import overlays from "./overlays";
import store from "./store";
import broadcast from "./broadcast";
import singleclick from "./singleclick";
// import "../../../maps-frontend/assets/css/svgs/simbolos/day.svg";


function findTimestampIndex(timestamps, ts, round, bound) {
    let index = 0
        , lastIndex = timestamps.length - 1;

    if (bound) {
        if (ts < timestamps[index])
            return index;
        if (ts > timestamps[lastIndex])
            return lastIndex
    }
    for (; index <= lastIndex; ) {
        let i = Math.floor((index + lastIndex) / 2)
            , prevTs = timestamps[i]
            , nextTs = timestamps[i + 1];

        if (round) {
            if (prevTs === ts)
                return i;
            if (prevTs < ts && ts < nextTs)
                return ts - prevTs < nextTs - ts ? i : i + 1;
        }else{
            if (prevTs <= ts && ts < nextTs)
                return i;
            if (ts === nextTs)
                return i + 1;
        }
        if ( prevTs < ts )
            index = i + 1;
        else
            lastIndex = i - 1;
    }
}

function datestr2timestamp(fechaStr) {

    // Extraer el año, mes y día del string
    const year = parseInt(fechaStr.substring(0, 4), 10);
    const month = parseInt(fechaStr.substring(4, 6), 10) - 1; // Los meses en JavaScript son 0-11
    const day = parseInt(fechaStr.substring(6, 8), 10);

    // Crear el objeto Date
    const fecha = new Date(year, month, day);

    return fecha.getTime();
}

// define("LabelsLayer", ["products", "http", "rootScope", "utils", "overlays", "store", "broadcast", "singleclick"], function(products, http, rscope, utils, overlays, store, broadcast, singleclick) { // e, t, n, i, s, a, r, o
    export default L.GridLayer.extend({
        options: {
            minZoom: 3,
            maxZoom: 11,
            pane: "markerPane",
            className: "labels-layer",
            updateWhenIdle: true,
            updateWhenZooming: false,
            keepBuffer: rscope.isMobileOrTablet ? 2 : 4,
            subdomains: 'abc',
        },
        tempConverter: overlays.temp2m.convertNumber,
        cityDivs: {},
        latestTs: 0,
        latestIndex: 0,
        ts: store.get("timestamp"),
        hasHooks: false,
        // className: "labels-layer",
        syncCounter: 0,
        forecastLoaded: false,
        loadSymbols: true,
        daily: false,

        onAdd: function() {
            if ( ! this.hasHooks )
            {
                this.updateProduct();
                this.createTilesUrl();
                singleclick.on("poi-label", this.onClick, this);
                store.on("timestamp", this.onTsChange, this);
                store.on("day", this.onDayChange, this);
                store.on("usedLang", this.updateLabels, this);
                store.on("englishLabels", this.updateLabels, this);
                // store.on("product", this.updateProduct.bind(this, "refresh"));
                store.on("pois", this.updateProduct.bind(this, true));
                // store.on("poisTemporary", this.updateProduct.bind(this, true));
                broadcast.on("metricChanged", this.refreshWeather, this);
                // store.on("overlay", this.refreshWeather, this);
                store.on("overlay", this.updateProduct.bind(this, true));

                this.hasHooks = true;
            }
            L.GridLayer.prototype.onAdd.call(this);
        },
        createTilesUrl: function() {
            this.usedLang = store.get("usedLang");
            let arrayLang = this.usedLang.split("_");
            let country = arrayLang[1];
            this.usedLang = arrayLang[0];

            // Si el país es España las etiquetas se ponen en español
            if (country === "ES")
                this.usedLang="es";

            // Si el idioma es noruego, swahili o malayo las etiquetas se ponen en inglés
            if (["no", "sw", "ms", "tl"].includes(this.usedLang))
                this.usedLang = "en";

            // var lang = store.get("englishLabels") ? "en" : store.get("usedLang");
            // var lang = "en";
            // this.tilesUrl = rscope.jsonServer + "/labels/v1.4/" + lang,
            //     this.fcstUrl = "https://ims-s.windy.com/forecast/citytile/v1.3"

            this.fcstUrl = rscope.jsonServer + "/web/tiles/symbols/"
            this.tilesUrl = rscope.jsonServer + "/img/labels";// + lang;
        },
        updateLabels: function() {
            this.createTilesUrl();
            this._reset();
        },
        updateProduct: function(t) {
            var nameProduct = store.get("product");
            var nameOverlay = store.get("overlay");

            this.daily = overlays[nameOverlay].daily;

            // var pois = store.get("pois");
            var loadSymbols = products[nameProduct].symbols && overlays[nameOverlay].symbols;
            // if ( ! products[nameProduct].labelsTemp )
            //     nameProduct = "ecmwf";

            // if ( ! products[nameProduct].symbols || ! overlays[nameOverlay].symbols)
            //     loadSymbols = false;
            var refTime = products[nameProduct].refTime();

            this.loadSymbols = loadSymbols;

            if (loadSymbols && (!this.forecastLoaded || this.product !== nameProduct || this.refTime !== refTime))
            {
                this.product = nameProduct;
                this.refTime = refTime;
            }

            if (t && loadSymbols)
                for (var citydiv in this.cityDivs)
                    this.cityDivs[citydiv].then((citydiv)=>{this.loadFcstTile(citydiv)})

        },
        onClick: function(element, t) {
            var id = t.id
                , label = t.label;

            if (t.lat && t.lon) {

                broadcast.emit("rqstOpen", "detail",{
                    coords: {
                        lat: t.lat,
                        lon: t.lon
                    },
                    title: label
                })
                // broadcast.emit("rqstOpen", "detail", {
                //     lat: lat,
                //     lon: lon,
                //     name: label,
                //     source: "label",
                //     sourceEl: element
                // })
            }
        },
        onTsChange: function(ts) {
            this.ts = ts;
            this.refreshWeather();
        },
        onDayChange: function(day){


        },
        toArray: async function() {
            var array = [];
            for (var city in this.cityDivs) {
                const cityDiv = await this.cityDivs[city];
                array = array.concat(cityDiv.labels);
            }
            return array
        },
        refreshWeather: async function() {

            var nameProduct = store.get("product");
            var nameOverlay = store.get("overlay");

            this.loadSymbols = products[nameProduct].symbols && overlays[nameOverlay].symbols;

            if (this.loadSymbols)
                for (const cityname in this.cityDivs) {
                    const city = await this.cityDivs[cityname],
                        index = this.getIndexToCityTileData(city.timestamps),
                        labels = city.labels;
                    for (let i = 0; i < labels.length; i++)
                        this.renderWeather(labels[i], index)
                }
        },
        _animateZoom: function() {
            this._removeAllTiles()
        },
        _reset: function() {
            this.redraw()
        },
        loadFcstTile: function(citydiv) {
            // if ( citydiv.labels.length )
            //     // http.get(this.fcstUrl + "/" + this.product + "/" + citydiv.urlFrag).then(
            //     http.get(this.fcstUrl + citydiv.urlFrag).then(
            //         this.onFcstLoaded.bind(this, this.syncCounter, citydiv)
            //     ).catch(function(e) {
            //         0
            //     })

            const nameOverlay = store.get("overlay")
                , nameProduct = store.get("product");

            let selectedPois = store.get("pois");

            if ( ! products[nameProduct].symbols || ! overlays[nameOverlay].symbols) {
                // this.loadSymbols = false;
                selectedPois = store.get("poisTemporary");
            }

            const urlFrag = this.daily ? citydiv.urlFragDaily : citydiv.urlFrag;

            if (selectedPois === "symbols" && citydiv.labels.length && urlFrag && this.product) {

                http.get(urlFrag, {cache: true}).then(
                    response => {
                        if (null != response && response.data) {
                            this.onFcstLoaded(citydiv, response.data);
                            this.forecastLoaded = true;
                        }
                    }
                )
            }
            else {
                citydiv.labels.forEach((label) => {
                        label.data = null;
                        // label.el.child
                        label.el.innerHTML = label.el.dataset.label;
                })
            }
        },
        onTileLoaded: function(syncCounter, coords , tile, jsonres) {
            var data = jsonres.data;
            if (syncCounter === this.syncCounter)
                return  this.renderTile(tile, coords, data)
        },
        getIndexToCityTileData(timestamps) {
            if (null != timestamps && timestamps.length)
                return findTimestampIndex(timestamps, this.ts, ! this.daily, this.daily);
        },
        onFcstLoaded: function(tilecities, data) {
            var labelslayer = this;
                //, data = jsonres.data;
            if (data && "object" == typeof data ) {
                // const hours = data.hours;
                const reftime = data.ref;

                if(this.daily)
                    tilecities.timestamps = data.days.map( day => datestr2timestamp(day) )
                else
                    tilecities.timestamps = data.hours.map( hour => reftime + hour * 3600 * 1000);

                // datestr2timestamp(fechaStr)
                // tilecities.timestamps = hours.map( hour => reftime + hour * 3600 * 1000);
                let index = this.getIndexToCityTileData(tilecities.timestamps);


                tilecities.labels.forEach(function(label) {
                    const id = label.id;
                    if ( id in data.forecast ){
                        label.data = data.forecast[id];
                        if (data.light)
                            label.light = data.light[id];
                        labelslayer.renderWeather(label, index)
                    }
                    else
                    {
                        label.data = null;

                        label.light = null;
                        label.el.removeAttribute("data-temp");
                    }
                })
            }
        },
        _getSubdomain: function (tilePoint) {
            const index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        createTile: function(coords, done) {
            var labelslayer = this
                , jsonfile = "{z}/{x}/{y}/" + this.usedLang
                , tile = L.DomUtil.create("div", "leaflet-tile")
                , data ={
                    z: coords.z,
                    x: coords.x,
                    y: coords.y,
                    s: this._getSubdomain(coords),
                    pasada: this.refTime
                }
            ;

            tile.style.width = tile.style.height = this.getTileSize() + "px";
            tile.onselectstart = tile.onmousemove = L.Util.falseFn;

            const urlJSON = utils.template(this.tilesUrl + "/" + jsonfile + ".json", data);
            const promise = http.get(urlJSON).then(this.onTileLoaded.bind(this, this.syncCounter, coords, tile));
            this.cityDivs[coords.x + ":" + coords.y] = promise;
            promise.then(
                function(cityDiv) {
                    if(cityDiv && data.pasada) {
                        cityDiv.urlFrag = utils.template(labelslayer.fcstUrl + "{z}/{x}/{y}/{pasada}.json", data);
                        cityDiv.urlFragDaily=cityDiv.urlFrag + "?tz=" + rscope.timezone;
                        labelslayer.loadFcstTile(cityDiv);
                        done(void 0, tile);
                    }else
                        done(void 0, tile);
                }
            ).catch(done);

            return tile;
        },
        renderTile: function(tile, coords, data) {

            var pos = this._getTilePos(coords),
                x0 = pos.x,
                y0 = pos.y,
                maporigin = this._map.getPixelOrigin(),
                mapx0 = maporigin.x,
                mapy0 = maporigin.y,
                width = 256 << coords.z, // Ancho (o alto) total del mapa: 256 para z0, 512 para z1, 1024 para z2, etc.
                citiesLabels = [];

            for (var h = 0; h < data.length; ++h) {
                var element = data[h]
                    , id = element.id
                    , name = element.name
                    , lon = element.lon
                    , lat = element.lat
                    , className = element.classcss
                    , wTitle = 0
                    , hTitle = 0
                    , isCity
                    , idDataset
                    , x = Math.floor(utils.lonDegToXUnit(lon) * width - mapx0 - wTitle / 2) - x0
                    , y = Math.floor(utils.latDegToYUnit(lat) * width - mapy0 - hTitle / 2) - y0
                    , divLabel = document.createElement("div");

                // if (element.class === 'country')
                //     className = element.rank<=2 ?  'country-1': 'country-2';
                // else if (element.class === 'city')
                //     className = element.rank<=2 ?  'city-1': 'city-2';

                isCity = "ci" === className.substr(0, 2);
                // idDataset = ! isCity ? id : lat.toFixed(2) + "/" + lon.toFixed(2);
                idDataset = id;

                divLabel.textContent = divLabel.dataset.label = name;
                divLabel.dataset.id = idDataset;
                divLabel.dataset.lon = lon.toFixed(4);
                divLabel.dataset.lat = lat.toFixed(4);
                divLabel.dataset.poi = "label";
                divLabel.className = className;
                divLabel.style.transform = "translate(" + x + "px, " + y + "px) translate(-50%, -50%)";
                // divLabel.style.width = wTitle + "px";


                if ( isCity )
                    // divLabel.dataset.temp = "10º",
                    citiesLabels.push({
                        id: idDataset,
                        el: divLabel,
                        lon: lon,
                        lat: lat
                    });
                tile.appendChild(divLabel)


            }
            return {
                labels: citiesLabels
            }
        },
        renderWeather: function(label, index) { //start, step, label
            if (label && label.el) {
                const {el: el, data: data, light: light} = label;
                if (null != data && data.length && void 0 !== index && index >= 0 && index < data.length) {
                    const elements = el.getElementsByClassName("simbolo");
                    let iconlight;
                    if(light)
                        iconlight = light[index] ? "day" : "night";
                    else
                        iconlight = "day";
                    let imgSymbol;
                    if (! elements || elements.length === 0){
                        imgSymbol = document.createElement("img");
                        imgSymbol.classList.add("simbolo");
                        imgSymbol.src = (rscope.resourcesServer ? rscope.resourcesServer  : "") + `css/svgs/simbolos/${iconlight}/${data[index]}.svg`;
                        el.appendChild(imgSymbol);

                    }else{
                        imgSymbol = elements[0];
                        imgSymbol.src = (rscope.resourcesServer ? rscope.resourcesServer  : "") + `css/svgs/simbolos/${iconlight}/${data[index]}.svg`;
                    }
                }
                else {
                    const elements = el.getElementsByClassName("simbolo");
                    if (elements && elements.length > 0) {
                        const imgSymbol = elements[0];
                        imgSymbol.src = "";
                    }
                }
            }
        }
        //     var element = label.el
        //         , data = label.data;
        //     if (element)
        //         if (data && data.length) {
        //             var time = this.ts - start
        //                 , index = Math.round(time / (step * utils.tsHour));
        //
        //             if (index >= 0 && index < data.length)
        //                 element.dataset.temp = this.tempConverter(data[index]) + "°"
        //             else
        //                 delete element.dataset.temp
        //         } else
        //             delete element.dataset.temp
        // }
    })
// });
